export default {
  feature: 'Функция',
  features: 'Функции',
  featuresOf: 'Функции {{type}}',
  'feature.list.title': 'Управление функциями',
  'feature.list.subtitle': 'Эффективно управляйте функциями приложения.',
  'feature.list.search.placeholder': 'Поиск функций по названию или описанию',
  'feature.info': 'Информация о функции',
  'feature.form.title': 'Название функции',
  'feature.form.description': 'Описание функции',
  'feature.form.assignments': 'Назначения',
  'feature.form.slug': 'Слаг',
  'feature.form.slug.helper':
    'Стабильный идентификатор для интеграций. Только латиница в нижнем регистре, цифры и подчёркивания (до 50 символов). Нельзя изменить, пока функция активна.',
  'feature.form.slug.invalid':
    'Слаг должен начинаться с латинской буквы в нижнем регистре и содержать только латиницу, цифры и подчёркивания (до 50 символов).',
  'feature.info.helper':
    'Укажите чёткое название, краткое описание и подходящий тип для определения функции',
  'feature.msg.deactivateBlocked': 'Деактивация заблокирована',
  'feature.msg.deactivateBlockedDescription':
    'Вы не можете деактивировать эту функцию, так как она уже используется в {{subscriptionName}}.',
  'feature.actions.navigateToSubscription': 'Перейти к подписке',
  'feature.utilityInfo': 'Параметры лимитов функции (Utility)',
  'feature.utility.cardTitle': 'Информация о счетчике лимита',
  'feature.utility.helper':
    'Настройте лимиты потребления и периоды сброса для этой функции',
  'feature.utility.enabled': 'Включить лимиты потребления?',
  'feature.utility.counter': 'Счетчик лимита',
  'feature.utility.duration': 'Период лимита',
  'feature.usage': 'Usage',
  'feature.save.confirm.title': 'Варианты сохранения',
  'feature.save.confirm.description':
    'Сохранить как новую или обновить существующую',
  'feature.assigned.subscriptions': 'Назначенные подписки ({{count}})',
  'feature.subscriptions.helper':
    'Чтобы назначить подписки, выберите их из списка активных подписок.',
  'feature.msg.unAssignConfirm':
    'Вы уверены, что хотите отменить назначение этой подписки?',
};
